import React, { useState, useRef, useEffect } from "react"
import { t, useTranslation } from "@/langs/useTranslation";
import {
  Typography, Card, CardContent, Grid, TextField, Button,
} from "@material-ui/core";
import useStyles from "./reduceStyle";
import CMSContentSelector from "@/components/FormFields/CMSContentSelector";
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import MediaPreview from "../../MediaPreview";
import { downloadFileLink } from "@/apis/announcementApi";
import { IconTrash } from "@/components/Icon";

const DisplayContent = ({ value, handleChange, readonly }) => {
  const { t } = useTranslation()
  const classes = useStyles()
  const [open, setOpen] = useState(false)

  const moveCard = (from, to) => {
    const updated = [...value];
    const [moved] = updated.splice(from, 1);
    updated.splice(to, 0, moved);
    handleChange({
      target: {
        name: "contentTemplateDetail.resources",
        value: updated.map((v, ind) => ({
          ...v,
          sort: ind + 1
        }))
      }
    })
  };

  const deleteCard = (ind) => {
    const newValue = [...value]
    newValue.splice(ind, 1)
    handleChange({
      target: {
        name: "contentTemplateDetail.resources",
        value: newValue.map((v, ind) => ({
          ...v,
          sort: ind + 1
        }))
      }
    })
  }

  const onConfirm = rows => {
    const values = [...value, ...rows.map(v => ({
      name: v.name,
      type: (v.mimeType || "").split("/")[1],
      previewType: (v.mimeType || "").split("/")[0],
      size: `${v.width}*${v.height}`,
      duration: v.duration || 1,
      s3Path: v.s3Path,
      resourceId: v.id,
    }))]
    handleChange({
      target: {
        name: "contentTemplateDetail.resources",
        value: values.map((v, ind) => ({
          ...v,
          sort: ind + 1
        }))
      }
    })
  }

  return (
    <DndProvider backend={HTML5Backend}>
      <div>
        <Button
          variant="contained"
          color="primary"
          onClick={() => setOpen(true)}
          disabled={readonly}
        >
          {t({ defaultMessage: "新增内容" })}
        </Button>
        <Grid container spacing={2} style={{ marginTop: 2 }}>
          {value.map((card, index) => (
            <DraggableCard
              key={card.resourceId}
              item={card}
              index={index}
              moveCard={moveCard}
              deleteCard={deleteCard}
              handleChange={handleChange}
              readonly={readonly}
            />
          ))}
        </Grid>

        {/* <CMSContentSelector open={open} onClose={() => setOpen(false)} onConfirm={onConfirm} status={3} /> */}
        <CMSContentSelector status={3} open={open} onClose={() => setOpen(false)} onConfirm={onConfirm} selectedIds={value.map(v => v.resourceId)} />
      </div>
    </DndProvider>
  )
}

const DraggableCard = React.memo(({ item, index, moveCard, deleteCard, handleChange, readonly }) => {
  const ref = useRef(null);
  const classes = useStyles();
  const [src, setSrc] = useState("")
  useEffect(() => {
    if (item.s3Path) {
      downloadFileLink(item.s3Path).then(({ download_link }) => {
        setSrc(download_link)
      })
    }
  }, [item.s3Path])

  const [, drop] = useDrop({
    accept: 'CARD',
    hover: (draggedItem) => {
      if (draggedItem.index !== index) {
        moveCard(draggedItem.index, index);
        draggedItem.index = index;
      }
    },
  });

  const [{ isDragging }, drag] = useDrag({
    type: 'CARD',
    item: { index },
    collect: (monitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  drag(drop(ref));

  return (
    <Grid item xs={3}>
      <div
        ref={ref}
        style={{
          opacity: isDragging ? 0.5 : 0.99,
          cursor: 'move',
        }}
      >
        <Card variant="outlined" className={classes.displayContent}>
          <CardContent style={{ padding: 0 }}>
            <div style={{ position: "relative" }}>
              <MediaPreview src={src} type={item.previewType} style={{ width: 208, height: 178, borderRadius: 6, objectFit: "cover", borderRaius: 6, margin: 0 }} />
              {!readonly && (
                <div
                  style={{ cursor: "pointer", position: "absolute", right: 0, top: 0, borderRadius: 6, backgroundColor: "rgba(0,0,0,0.4)", width: 28, height: 28, display: "flex", justifyContent: "center", alignItems: "center" }}
                  onClick={() => deleteCard(item.sort - 1)}
                >
                  <IconTrash color="white" size={16} />
                </div>
              )}
            </div>
            <Typography variant="subtitle2" style={{ marginTop: 16, marginBottom: 8, whiteSpace: "nowrap", textOverflow: "ellipsis", overflow: "hidden" }}>
              {t({ defaultMessage: "名称: {name}" }, item)}
            </Typography>
            <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
              {t({ defaultMessage: "类型: {type}" }, item)}
            </Typography>
            <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
              {t({ defaultMessage: "尺寸: {size}" }, item)}
            </Typography>
            <Typography variant="subtitle2" style={{ marginBottom: 8 }}>
              {t({ defaultMessage: "顺序: {sort}" }, item)}
            </Typography>
            <Typography variant="subtitle2" style={{whiteSpace: "nowrap"}}>
              {t({ defaultMessage: "时长: " })}
              <TextField
                style={{ marginLeft: 8, width: 150 }}
                inputProps={{
                  style: {
                    paddingTop: 0, paddingBottom: 4, paddingLeft: 8
                  },
                  // endAdornment: <InputAdornment position="end">s</InputAdornment>
                }}
                value={item.duration}
                disabled={readonly || item.previewType === "video"}
                name={`contentTemplateDetail.resources[${item.sort - 1}].duration`}
                type="number"
                onChange={(e) => {
                  if (Number(e.target.value) < 1) e.target.value = "1"
                  handleChange(e)
                }}
              // onChange={handleChange}
              />
              s
            </Typography>
          </CardContent>
        </Card>
      </div>
    </Grid>
  );
});

export default DisplayContent
